import _ from 'lodash';

import { FETCH_PAYMENTS, FETCH_PAYMENT, CREATE_PAYMENT, DELETE_PAYMENT } from "../actions/PaymentActions";


const paymentReducer = function(state = [], action) {
  switch (action.type) {
    case FETCH_PAYMENTS:
      return _.mapKeys(action.payload, 'ttid');
    case FETCH_PAYMENT:
      return { ...state, [action.payload.ttid]: action.payload };
    case CREATE_PAYMENT:
      return { ...state, [action.payload.ttid]: action.payload };
    case DELETE_PAYMENT: {
      return _.omit(state, action.payload);
    }
    default:
      return state;
  }
};

export default paymentReducer;
